import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlListaNatureza = '/service/materiais/obras/'

class TipoNaturezaObraService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTipoNaturezaObra() {
        return this.conex.get(urlListaNatureza + 'listaNatureza/')
    }
}

export default TipoNaturezaObraService
